import { adexp } from '@paramount-streaming/blackbird';
import { ITagAbstractClassArgument } from 'tag/ts/tag/interfaces/arguments/ITagAbstractClassArgument';
import { IAviaPlugin } from 'tag/ts/tag/player/adapters/avia/interfaces/IAviaPlugin';
import { AviaPlugin } from 'tag/ts/tag/player/adapters/avia/plugins/AviaPlugin';
import { TPluginConfigFactory } from 'tag/ts/tag/player/adapters/avia/types/TPluginConfigFactory';

/**
 * @copyright © Paramount Streaming
 * @description Wraps Ad Experience (adexp) plugin from Pluto TV Blackbird for SmartTag.
 * Manages grace period logic for the Avia Player (start and mid-roll grace periods).
 * @see https://playback-docs.webctv.plutostaging.tv/docs/plugins/adexp
 */
export class AdExpPlugin extends AviaPlugin implements IAviaPlugin {
	package = adexp as unknown as TPluginConfigFactory;
	namespaceKey = 'plugin_adexp';

	constructor( argument: ITagAbstractClassArgument ) {
		super(
			{
				...argument,
				name: 'AdExpPlugin'
			}
		);
	}

	/**
	 * Should be used if params.STITCHER is non-empty
	 * @returns {boolean}
	 */
	shouldBeUsed() {
		return this.hasStitcherParams();
	}

	/**
	 * Returns parameters required to initialize adexp from Pluto TV Blackbird.
	 * Options: gracePeriodDuration (start/mid grace seconds), uiContainer (selector for engagement events).
	 * Reads from tag config (AdExp.params) with fallbacks to defaults.
	 * @see https://playback-docs.webctv.plutostaging.tv/docs/plugins/adexp
	 */
	getFactoryParams() {
		const params = this.tag?.model?.config?.tag?.AdExp?.params;
		const defaultGracePeriod = { startGracePeriodSeconds: 30, midGracePeriodSeconds: 15 };
		return {
			...super.getFactoryParams(),
			gracePeriodDuration: params?.gracePeriodDuration ?? defaultGracePeriod,
			uiContainer: params?.uiContainer ?? '#player-ui'
		};
	}
}